import React from "react";
import { Link } from "react-router-dom";
import "./LandingUseCase.css";

/**
 * One service section: copy on one side, illustration on the other.
 *
 * Replaces the seven bespoke components that each carried an IntersectionObserver
 * whose only remaining effect was a console.log — the fade-in CSS it drove had
 * been commented out, so the observer animated nothing.
 *
 * `index` drives the alternating layout: even sections put the image on the
 * right on a white background, odd sections mirror it on a tinted one.
 */
function UseCaseSection({ useCase, index }) {
  const mirrored = index % 2 === 1;

  return (
    <section
      className={`usecase ${mirrored ? "usecase--alt" : ""}`}
      aria-labelledby={`${useCase.id}-title`}
    >
      <div
        className={`container usecase__inner ${
          mirrored ? "usecase__inner--mirrored" : ""
        }`}
      >
        <div className="usecase__content">
          {/* h2, not h1: the home page has exactly one h1 in the hero. */}
          <h2 className="usecase__title" id={`${useCase.id}-title`}>
            {useCase.title}
          </h2>
          <p className="usecase__body">{useCase.body}</p>
          <ul className="usecase__list">
            {useCase.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <Link to={useCase.href} className="usecase__button">
            Explore more
            <span aria-hidden="true"> &rarr;</span>
          </Link>
        </div>

        <div className="usecase__media">
          <picture>
            <source srcSet={useCase.webp} type="image/webp" />
            <img
              src={useCase.img}
              alt={useCase.alt}
              width={useCase.width}
              height={useCase.height}
              /* All seven sit below the fold, and width/height reserve the box
                 so lazy loading does not shift the page as they arrive. */
              loading="lazy"
              decoding="async"
              className="usecase__img"
            />
          </picture>
        </div>
      </div>
    </section>
  );
}

export default UseCaseSection;
